export default {"src":"/_next/static/media/no_review_post.87f9443c.gif","height":400,"width":400,"blurWidth":0,"blurHeight":0};